import React from 'react';
import ReactDOM from 'react-dom';
import ImageGallery from 'react-image-gallery';
import Service from './ImageService';


export default class ImageBankGallery extends React.Component {

    constructor(props) {
        super(props);
        this.loadData();
        this.state = {
            items: []
        };  
    }

    render() {      
        return (
            <ImageGallery
                ref={i => this._imageGallery = i}
                showThumbnails={false}
                showPlayButton={false}
                showFullscreenButton= {false}
                items={this.state.items}
                autoPlay={true}
                renderItem={this.renderItem}
                slideInterval={5000}
                slideDuration={750} />
            );
    }


    //_onImageClick(event) {
    //    console.log('clicked on image', event.target, 'at index', this._imageGallery.getCurrentIndex());
    //    this.state.items
    //}

    renderItem(item) {

       var component = (<img src={item.image.websitePath} alt = "image-gallery" />);
        if (item.image.alt != "") {
            component = (<img src={item.image.websitePath} alt={item.image.alt} />);
        }
       
        if (item.link && item.openNewBlank) {
            return (
                <a href={item.link} target="_blank" rel="noopener">
                    {component}
                </a>
            );
        }

        if (item.link && !item.openNewBlank) {
            return (
                <a href={item.link}>
                    {component}
                </a>
            );
        }
        return component;
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        Service.getImageItems()
            .then(res => {
                this.setState({
                    items: res
                });
            })
    }

}

var root = document.getElementById('js-image-plugin');

if (!!root) {
    ReactDOM.render(<ImageBankGallery />, root);
}



// WEBPACK FOOTER //
// ./Src/Components/ImageGallery/ImageGallery.jsx